import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import api, { formatApiErrorDetail } from "@/lib/api";
import PrivacyNotice from "@/components/PrivacyNotice";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", {
        email,
      });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-page" className="min-h-[80vh] max-w-md mx-auto px-6 py-20">
      <div className="label-eyebrow text-sage mb-3">Folio account</div>
      <h1 className="font-serif text-5xl tracking-tight mb-2">Forgot password.</h1>
      <p className="text-muted_ink mb-10">
        Enter your email and we'll send a link to choose a new one.
      </p>

      {submitted ? (
        <div data-testid="forgot-success" className="border border-edge p-6 bg-white">
          <div className="font-serif text-2xl">Check your inbox.</div>
          <p className="text-muted_ink mt-2 text-sm">
            If an account exists for <span className="text-ink">{email}</span>, a reset link is on its way. The link expires in one hour.
          </p>
          <Link to="/login" className="btn-secondary mt-6 inline-flex">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="label-eyebrow block mb-2">Email</label>
            <Input
              data-testid="forgot-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-12 bg-transparent border border-edge rounded-none focus-visible:ring-terracotta focus-visible:ring-1"
            />
          </div>
          {error && (
            <div data-testid="forgot-error" className="text-sm text-terracotta border-l-2 border-terracotta pl-3">{error}</div>
          )}
          <button
            data-testid="forgot-submit-btn"
            type="submit"
            disabled={loading}
            className="btn-primary w-full disabled:opacity-60"
          >
            {loading ? "Sending…" : "Send reset link"}
          </button>
          <PrivacyNotice
            testid="forgot-privacy"
            purpose="We use your email only to send the password reset link."
          />
        </form>
      )}

      <div className="text-center mt-8 text-sm text-muted_ink">
        <Link to="/login" data-testid="forgot-back-link" className="underline underline-offset-4 decoration-terracotta">
          Back to sign in
        </Link>
      </div>
    </div>
  );
}
